import {
  Autocomplete,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CNumberField from '../../../components/CNumberField';
// import lgotaService from '../../../services/lgotaService';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

type propsType = {
  product?: any;
  products?: any;
  removeProduct?: any;
  index?: any;
  changeHandler?: any;
  computedCatalogList?: any;
  hasExcise?: any;
  formik?: any;
  hasCommittent?: any;
};
const ProductItem = (props: propsType) => {
  let {
    product,
    products,
    removeProduct,
    index,
    changeHandler,
    computedCatalogList,
    hasExcise,
    formik,
    hasCommittent,
  } = props;
  // const [lgotaList, setLgotaList] = useState<any>([]);
  const [packageNamesList, setPackageNamesList] = useState<any>([]);

  // Get catalog list from Redux store
  // @ts-ignore
  const catalogList = useSelector(state => state.measures.catalogList);

  // Get translation function
  const { t } = useTranslation();

  const countChangeHandler = (val: any) => {
    changeHandler(index, 'count', val);
    const deliverySum = Number(val) * Number(product.summa);
    changeHandler(index, 'deliverySum', isNaN(deliverySum) ? 0 : deliverySum);

    let vatSum = (Number(product.vatRate) * deliverySum) / 100;
    vatSum = isNaN(vatSum) || vatSum < 0 ? 0 : vatSum;
    changeHandler(index, 'vatSum', vatSum);

    const deliverySumWithVat = vatSum + deliverySum;
    changeHandler(
      index,
      'deliverySumWithVat',
      isNaN(deliverySumWithVat) ? 0 : deliverySumWithVat,
    );
  };

  const deliverySumChangeHandler = (val: any) => {
    if (Number(product.summa) === 0 && val > 0) {
      changeHandler(index, 'deliverySum', 0);
    } else {
      changeHandler(index, 'deliverySum', val);
    }
  };
  const summaChangeHandler = (val: any) => {
    changeHandler(index, 'summa', val);
    const deliverySum = Number(product.count) * Number(val);
    changeHandler(
      index,
      'deliverySum',
      isNaN(deliverySum) || deliverySum < 0 ? 0 : deliverySum,
    );

    let vatSum = (Number(product.vatRate) * deliverySum) / 100;
    vatSum = isNaN(vatSum) || vatSum < 0 ? 0 : vatSum;
    changeHandler(index, 'vatSum', vatSum);

    const deliverySumWithVat = vatSum + deliverySum;
    changeHandler(
      index,
      'deliverySumWithVat',
      isNaN(deliverySumWithVat) ? 0 : deliverySumWithVat,
    );
  };

  // @ts-ignore
  const vatRateChangeHandler = val => {
    if (val < 0) {
      changeHandler(index, 'withoutVat', true);
      formik.setFieldValue('productList.hasVat', false);
    } else {
      changeHandler(index, 'vatRate', Number(val));
      changeHandler(index, 'withoutVat', false);
    }

    let vatSum = (Number(val) * Number(product.deliverySum)) / 100;
    vatSum = isNaN(vatSum) || vatSum < 0 ? 0 : vatSum;
    changeHandler(index, 'vatSum', vatSum);

    const deliverySumWithVat = vatSum + Number(product.deliverySum);
    changeHandler(
      index,
      'deliverySumWithVat',
      isNaN(deliverySumWithVat) ? 0 : deliverySumWithVat,
    );

    // // If VAT rate is 0 or -1, check for privileges
    // if (val <= 0 && product.catalogCode) {
    //   console.log("VAT rate set to 0 or -1, checking for privileges");
    //   searchLgotaId(product.catalogCode);
    // } else {
    //   // Clear privileges when VAT rate is positive
    //   changeHandler(index, 'lgotaName', null);
    //   changeHandler(index, 'lgotaId', null);
    // }
  };
  // // console.log("formik===", JSON.stringify(formik, null, 2));
  // const tinsSecond = formik?.values?.buyerTin !== '' ? false : true;

  // const searchLgotaId = (mxik = '') => {
  //   console.log("Searching for privileges for product code:", mxik);
  //   console.log("Seller TIN:", formik?.values?.sellerTin);

  //   lgotaService
  //     .fetchLgotaNew({
  //       mxik: [mxik],
  //       tins: tinsSecond
  //         ? [formik?.values?.sellerTin]
  //         : [formik?.values?.sellerTin, formik?.values?.buyerTin],
  //       checkDate: formik.values.facturaDoc.facturaDate,
  //     })
  //     .then((res: any) => {
  //       console.log("Privilege response:", res);
  //       const lgotas = [];

  //       // Add product specific privileges
  //       if (res.product && res.product[`${mxik}`] && res.product[`${mxik}`].withoutVat) {
  //         for (let i = 0; i < res.product[`${mxik}`].withoutVat.length; i++) {
  //           lgotas.push(res.product[`${mxik}`].withoutVat[i]);
  //         }
  //       }

  //       // Add seller privileges
  //       if (res.company && res.company[`${formik?.values?.sellerTin}`]) {
  //         // Include ALL seller privileges regardless of catalog codes
  //         // This is a critical change since the API's catalogCodes matching might work differently
  //         const sellerWithoutVat = res.company[`${formik?.values?.sellerTin}`]?.sellerWithoutVat || [];

  //         console.log("All seller privileges:", sellerWithoutVat);

  //         // Simply add all privileges from sellerWithoutVat
  //         for (let i = 0; i < sellerWithoutVat.length; i++) {
  //           console.log("Adding seller privilege:", sellerWithoutVat[i]);
  //           lgotas.push(sellerWithoutVat[i]);
  //         }

  //         // Add from sellerLgotas for backward compatibility
  //         const sellerLgotas = res.company[`${formik?.values?.sellerTin}`]?.sellerLgotas || [];
  //         for (let i = 0; i < sellerLgotas.length; i++) {
  //           lgotas.push(sellerLgotas[i]);
  //         }
  //       }

  //       // Add buyer privileges
  //       if (res.company && res.company[`${formik?.values?.buyerTin}`]) {
  //         const buyerLgotas = res.company[`${formik?.values?.buyerTin}`]?.buyerLgotas || [];
  //         for (let i = 0; i < buyerLgotas.length; i++) {
  //           lgotas.push(buyerLgotas[i]);
  //         }
  //       }

  //       console.log('Loaded privileges:', lgotas);
  //       setLgotaList(lgotas);

  //       // If no VAT rate is set or it's -1 (без НДС), and we have privileges, select the first one
  //       if ((product.vatRate === -1 || product.vatRate === 0) && lgotas.length > 0) {
  //         console.log("Automatically selecting first privilege since vatRate is 0 or -1");
  //         changeHandler(index, 'lgotaId', lgotas[0].lgotaId);
  //         changeHandler(index, 'lgotaName', lgotas[0].lgotaName);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching privileges:", error);
  //     });
  // };

  // useEffect(() => {
  //   if (product.catalogCode !== '') searchLgotaId(product.catalogCode);
  // }, [product.catalogCode]);

  // const computedLgotaList = useMemo(() => {
  //   if (!lgotaList?.length) return [];

  //   console.log('Building privilege dropdown from lgotaList:', lgotaList);

  //   // Map lgota list to dropdown options
  //   const options = lgotaList.map((lgota: any) => {
  //     // Create a sanitized option object
  //     return {
  //       label: lgota.lgotaName || 'Unnamed privilege',
  //       value: lgota.lgotaId || 0,
  //       // Include the original object for reference
  //       originalData: lgota
  //     };
  //   });

  //   console.log('Final privilege dropdown options:', options);
  //   return options;
  // }, [lgotaList]);

  useEffect(() => {
    if (product.catalogCode !== '' && catalogList && !product.packageCode) {
      // @ts-ignore
      const catalogData = catalogList.find(catalog => catalog.mxikCode === product.catalogCode);

      // If packageNames exist, update the product with them and select the first one
      if (catalogData && catalogData.packageNames && catalogData.packageNames.length > 0) {
        // Store packageNames in local state instead of product object
        setPackageNamesList(catalogData.packageNames);

        // Store the first package code and name
        changeHandler(index, 'packageCode', catalogData.packageNames[0].code);
        changeHandler(index, 'packageName', catalogData.packageNames[0].nameRu);
      }
    }
  }, [product.catalogCode, catalogList]);

  // useEffect(() => {
  //   if (product.vatRate !== 0) {
  //     changeHandler(index, 'lgotaName', null);
  //     changeHandler(index, 'lgotaId', null);
  //   }
  // }, [product.vatRate]);

  return (
    <tr className="products__tr">
      <td className="products__td">{index + 1}</td>
      {hasCommittent && (
        <>
          <td className="products__td">
            <TextField
              fullWidth
              value={product.committentName}
              onChange={e =>
                changeHandler(index, 'committentName', e.target.value)
              }
            />
          </td>

          <td className="products__td">
            <TextField
              fullWidth
              value={product.committentTin}
              onChange={e =>
                changeHandler(index, 'committentTin', e.target.value)
              }
            />
          </td>
          <td className="products__td">
            <TextField
              fullWidth
              value={product.committentVatRegCode}
              onChange={e =>
                changeHandler(index, 'committentVatRegCode', e.target.value)
              }
            />
          </td>
        </>
      )}
      <td className="products__td">
        <Autocomplete
          options={computedCatalogList}
          onChange={(e, value) => {
            if (!value) {
              // Handle clearing the selection
              changeHandler(index, 'catalogCode', '');
              changeHandler(index, 'catalogName', '');
              // Clear the local packageNames state instead of the product.packageNames
              setPackageNamesList([]);
              changeHandler(index, 'packageCode', '');
              changeHandler(index, 'packageName', '');
              return;
            }

            // @ts-ignore
            changeHandler(index, 'catalogCode', value.value);

            // Get the catalog data from the original catalog list
            if (value.value && catalogList) {
              // @ts-ignore
              const catalogData = catalogList.find(catalog => catalog.mxikCode === value.value);

              // If packageNames exist, update the product with them and select the first one
              if (catalogData && catalogData.packageNames && catalogData.packageNames.length > 0) {
                // Store packageNames in local state instead of product object
                setPackageNamesList(catalogData.packageNames);

                // Store the first package code and name
                changeHandler(index, 'packageCode', catalogData.packageNames[0].code);
                changeHandler(index, 'packageName', catalogData.packageNames[0].nameRu);
              }
            }
          }}
          value={product.catalogCode ?
            (product.catalogName ? `${product.catalogCode} - ${product.catalogName}` : product.catalogCode) :
            null
          }
          renderInput={params => <TextField {...params} />}
        />
      </td>
      <td className="products__td">
        <TextField
          fullWidth
          value={product.name}
          onChange={e => changeHandler(index, 'name', e.target.value)}
        />
      </td>
      <td className="products__td">
        <TextField
          fullWidth
          value={product.barcode}
          onChange={e => changeHandler(index, 'barcode', e.target.value)}
        />
      </td>

      <td className="products__td">
        {packageNamesList.length > 0 ? (
          <FormControl fullWidth>
            <Select
              value={product.packageCode || ''}
              onChange={(e) => {
                const selectedCode = e.target.value;
                // Save the selected package code
                changeHandler(index, 'packageCode', selectedCode);

                // Update package name reference if needed
                const selectedPackage = packageNamesList.find((pkg: any) => pkg.code === selectedCode);
                if (selectedPackage) {
                  changeHandler(index, 'packageName', selectedPackage.nameRu);
                }
              }}>
              {packageNamesList.map((pkg: any) => (
                <MenuItem key={pkg.code} value={pkg.code}>
                  {pkg.nameRu}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <TextField
            fullWidth
            disabled
            value=""
            placeholder={t?.('measurementUnit') || 'Measurement Unit'}
          />
        )}
      </td>

      <td className="products__td">
        <CNumberField
          fullWidth
          value={product.count}
          // @ts-ignore
          onChange={countChangeHandler}
        />
      </td>
      <td className="products__td">
        <CNumberField
          fullWidth
          value={product.summa}
          // @ts-ignore
          onChange={summaChangeHandler}
        />
      </td>
      <td className="products__td">
        <CNumberField
          fullWidth
          value={product.deliverySum}
          // @ts-ignore
          onChange={deliverySumChangeHandler}
        />
      </td>
      <td className="products__td">
        <FormControl fullWidth>
          <Select
            value={product.vatRate}
            onChange={e => vatRateChangeHandler(e.target.value)}>
            <MenuItem value={-1}>Без НДС</MenuItem>
            <MenuItem value={0}>0%</MenuItem>
            <MenuItem value={12}>12%</MenuItem>
          </Select>
        </FormControl>
      </td>
      <td className="products__td">
        <CNumberField disabled fullWidth value={product.vatSum} />
      </td>

      {hasExcise && (
        <>
          <td className="products__td">
            <CNumberField
              fullWidth
              value={product.exciseRate}
              // @ts-ignore
              onChange={val => changeHandler(index, 'exciseRate', val)}
            />
          </td>

          <td className="products__td">
            <CNumberField fullWidth value={product.exciseSum} disabled />
          </td>
        </>
      )}

      {/* <td className="products__td">
        <Autocomplete
          options={computedLgotaList || []}
          onChange={(e, value) => {
            if (!value) {
              // Handle clearing the selection
              changeHandler(index, 'lgotaId', null);
              changeHandler(index, 'lgotaName', null);
              return;
            }

            // @ts-ignore
            changeHandler(index, 'lgotaId', `${value.value}`);
            // @ts-ignore
            changeHandler(index, 'lgotaName', value.label);
          }}
          value={product.lgotaId ?
            { label: product.lgotaName, value: product.lgotaId } :
            null
          }
          renderInput={params => (
            <TextField {...params} placeholder="Выберите привилегию" />
          )}
          sx={{
            minWidth: 250,
            '& .MuiAutocomplete-listbox': {
              minWidth: 300
            }
          }}
        />
      </td> */}

      <td className="products__td">
        <CNumberField
          // @ts-ignore
          value={Math.round(product.deliverySumWithVat)}
        />
      </td>
      <td className="products__td">
        <FormControl fullWidth>
          <Select
            value={product.origin}
            onChange={e => changeHandler(index, 'origin', e.target.value)}>
            <MenuItem value={1}>Производство от себя</MenuItem>
            <MenuItem value={2}>Выкуплено</MenuItem>
            <MenuItem value={3}>Предоставление услуги</MenuItem>
            <MenuItem value={4}>Не участвую</MenuItem>
          </Select>
        </FormControl>
      </td>

      <td className="products__td">
        {products.length > 1 && (
          <IconButton color="error" onClick={() => removeProduct(index)}>
            <DeleteIcon />
          </IconButton>
        )}
      </td>
    </tr>
  );
};

export default ProductItem;
